import React from 'react';
import { MdClose } from 'react-icons/md';
import './styles/frequentlyboughtcards.css';
export interface FBItem {
	id: string;
	title: string;
	price: string;
	img?: string;
}

interface Props {
	items?: FBItem[];
	selectedIds?: string[];
	onToggle?: (id: string) => void;
	onCardClick?: (id: string) => void;
}

const MOCK: FBItem[] = [
	{ id: 'a', title: 'Ultro Tech Cement 50kg (1 pack)', price: '₹ 1,799', img: '/public/images/logo.jpg' },
	{ id: 'b', title: 'Birla White (White Cement) 1 kg', price: '₹ 1,799', img: '/public/images/banner.svg' },
];

const FrequentlyBoughtCards: React.FC<Props> = ({ 
	items = MOCK, 
	onToggle,
	onCardClick
}) => {
	return (
		<div className="fb-grid">
			{items.map(i => (
				<div key={i.id} className="fb-card" onClick={() => onCardClick?.(i.id)} style={{ cursor: onCardClick ? 'pointer' : 'default', position: 'relative' }}>
					{onToggle ? (
						<button
							onClick={(e) => { e.stopPropagation(); onToggle(i.id); }}
							className="fb-card-remove-button"
							aria-label="Remove from selection"
							title="Remove from selection"
						>
							<MdClose size={22} />
						</button>
					) : null}
					<img src={i.img} alt={i.title} className="fb-card-image" />
					<div className="fb-card-footer">
						<div className="fb-card-title">{i.title}</div>
						<div className="fb-card-price">{i.price}</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default FrequentlyBoughtCards;
